import { Outlet } from 'react-router-dom';

const Inspection = () => <Outlet />;

export default Inspection;
